/**
 * Pevná paleta 12 barev tras (Anatomie plánovače tras §5). Barva se promítá do tečky v seznamu,
 * čísel zastávek a linie v mapě. Hodnota se ukládá jako hex string (`StationChain.Color`).
 */
export const STATION_CHAIN_COLORS: readonly string[] = [
  '#2563eb', // modrá
  '#dc2626', // červená
  '#16a34a', // zelená
  '#d97706', // oranžová
  '#7c3aed', // fialová
  '#0891b2', // tyrkysová
  '#db2777', // růžová
  '#65a30d', // limetková
  '#ca8a04', // zlatá
  '#0d9488', // smaragdová
  '#4f46e5', // indigo
  '#b45309', // hnědá
];

/** Výchozí barva nové trasy. */
export const DEFAULT_STATION_CHAIN_COLOR = STATION_CHAIN_COLORS[0];
